var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getPercent } from "../Utils/HelperFunctions";
import { MdStar } from 'react-icons/md';
export default function Checkpoint(props) {
    var _a = useState(getPercent(props.position)), position = _a[0], setPosition = _a[1];
    var _b = useState(false), showDetails = _b[0], setShowDetails = _b[1];
    useEffect(function () {
        setPosition(getPercent(props.position));
    }, [props.position]);
    var style = {
        left: position + "%",
    };
    return (_jsxs("div", __assign({ onMouseEnter: function () { return setShowDetails(true); }, onMouseLeave: function () { return setShowDetails(false); }, className: 'bl-progress-bar-checkpoint', style: style }, { children: [_jsx("div", __assign({ className: 'bl-progress-bar-value bl-progress-bar-checkpoint-value', style: { position: "absolute", marginBottom: '40px', color: props.accomplished ? "black" : props.unfilledColor } }, { children: props.checkpoint.Label }), void 0), props.useIcons && _jsx(MdStar, { style: props.accomplished ? { color: props.filledColor } : { color: props.unfilledColor } }, void 0), _jsx("div", __assign({ className: "bl-progress-bar-value bl-progress-bar-checkpoint-details " + (showDetails ? '' : 'hide'), style: { position: "absolute", marginTop: '60px', width: '100px' } }, { children: props.checkpoint.Value + ": " + props.checkpoint.Details }), void 0)] }), void 0));
}
